import { createSelector } from 'reselect'
import { isDeleted } from '../utils/state'
import { selectCurrentConversation } from './selectCurrentConversation'

export const selectCurrentConversationIsDeleted = createSelector(
  selectCurrentConversation,
  isDeleted
)
